var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMnAdmGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.981,
    height: 21.483,
    viewBox: "0 0 24.981 21.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_mn_adm_grey",
    transform: "translate(-0.1 -4.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9957",
    "data-name": "Path 9957",
    d: "M23.689,26.383H1.456A1.355,1.355,0,0,1,.1,25.027V6.256A1.355,1.355,0,0,1,1.456,4.9H23.725a1.355,1.355,0,0,1,1.356,1.356V25.063A1.4,1.4,0,0,1,23.689,26.383Z",
    transform: "translate(0 0)",
    fill: "#1aae95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9964",
    "data-name": "Path 9964",
    d: "M21.128,24.024H1.309A1.207,1.207,0,0,1,.1,22.817V6.107A1.207,1.207,0,0,1,1.309,4.9H21.16a1.207,1.207,0,0,1,1.209,1.207V22.848A1.252,1.252,0,0,1,21.128,24.024Z",
    transform: "translate(1.356 2.36)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(1.527 8.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9958",
    "data-name": "Path 9958",
    d: "M4.1,18.611V16.933c.071-.107.143-.107.25-.107h11.6c.357,0,.393-.036.464-.393a3.573,3.573,0,0,1,1.142-1.856,2.852,2.852,0,0,1,1.784-.678h6.281a.706.706,0,0,1,.393.071,1.094,1.094,0,0,1,.143.607V15.72H19.445a1.491,1.491,0,0,0-1.5,1.249,1.214,1.214,0,0,0-.036.357c-.071.749-.428,1.213-1.106,1.285a3.462,3.462,0,0,1-.607.036H4.385C4.35,18.611,4.243,18.611,4.1,18.611Z",
    transform: "translate(-4.1 -13.9)",
    fill: "#d3d1d2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9959",
    "data-name": "Path 9959",
    d: "M23.689,35.323H1.456A1.355,1.355,0,0,1,.1,33.967V23.154a1.713,1.713,0,0,1,1.713-1.713H14.232l1.106-2.07a1.029,1.029,0,0,1,.928-.571h7.708a1.051,1.051,0,0,1,1.071,1.071v14.1A1.355,1.355,0,0,1,23.689,35.323Z",
    transform: "translate(0 -8.94)",
    fill: "#2fc8b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9960",
    "data-name": "Path 9960",
    d: "M50.262,22.114H47.085a.366.366,0,0,1,0-.714h6.352a.36.36,0,0,1,.321.393.349.349,0,0,1-.321.357h-.25C52.189,22.114,51.225,22.114,50.262,22.114Z",
    transform: "translate(-30.034 -10.612)",
    fill: "#3a484a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9961",
    "data-name": "Path 9961",
    d: "M31.964,43.928a2.166,2.166,0,0,1-1.5-.607c-.214-.214-.25-.428-.071-.607a.4.4,0,0,1,.571.036,1.38,1.38,0,0,0,2,0,.4.4,0,0,1,.571-.036.405.405,0,0,1-.071.571A1.878,1.878,0,0,1,31.964,43.928Z",
    transform: "translate(-19.41 -24.253)",
    fill: "#3a484a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9962",
    "data-name": "Path 9962",
    d: "M19.849,41.021v.464c-.036.25-.178.393-.357.393a.389.389,0,0,1-.393-.357v-.964a.337.337,0,0,1,.357-.357.389.389,0,0,1,.393.357v.464Z",
    transform: "translate(-12.22 -22.703)",
    fill: "#3a484a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9963",
    "data-name": "Path 9963",
    d: "M49.5,40.956v.5c-.036.214-.143.357-.393.321a.33.33,0,0,1-.357-.321,5.016,5.016,0,0,1,0-1.035c0-.214.143-.321.357-.321a.36.36,0,0,1,.393.321A2.677,2.677,0,0,1,49.5,40.956Z",
    transform: "translate(-31.272 -22.638)",
    fill: "#3a484a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMnAdmGreen);
export default __webpack_public_path__ + "static/media/ic_mn_adm_green.2b95a3999e3c093938d7d8388d41f786.svg";
export { ForwardRef as ReactComponent };